import React, { useMemo } from 'react';
import Accordion from 'components/Accordion';
import useEmergency from 'hooks/Meteorology/Agro/WaterBalanceCulture/DetailedView/useEmergency';
import DatePicker from 'components/DatePicker';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';

export default function Emergency() {
  const { dateIntervals, emergencyDate, changeEmergencyDate } = useEmergency();
  const closeAccordion = useMemo(() => buildAccordionClickFunction('emergency-accordion'), []);
  return (
    <Accordion.Item eventKey="emergency" id="emergency-accordion">
      <Accordion.Header>Data da Emergência</Accordion.Header>
      <Accordion.Body>
        <DatePicker
          selected={emergencyDate}
          onChange={(newDate) => { changeEmergencyDate(newDate); closeAccordion(); }}
          includeDateIntervals={dateIntervals}
          inline
        />
      </Accordion.Body>
    </Accordion.Item>
  );
}
